export const leadsPlusCartController = 'leads_plus_cart';

export const newLeadsPlusController = '/leadsplus/home/';

export const leadsPlusCartControllerPath = `/dashboard/${leadsPlusCartController}`;

export const leadsPlusController = 'leads_plus';

export const leadsPlusControllerPath = `/dashboard/${leadsPlusController}`;

export const intranetController = 'geo_data';

export const getGeoDataFunction = 'getGeoDataForFrontEnd';

export const intranetControllerPath = `/${intranetController}`;
